import React from 'react';

const GallerySection = ({ eventData, imageURLs }) => {
  return (
    <section className="bg-gradient-to-br from-orange-50 via-pink-50 to-purple-50 text-gray-800 py-16 px-4 text-center relative">
      <div className="max-w-6xl mx-auto relative z-10">
        <div className="bg-white rounded-lg p-8 shadow-xl border border-orange-200">
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-pink-500 rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold mb-6 bg-gradient-to-r from-orange-600 via-pink-500 to-purple-600 bg-clip-text text-transparent">
            Event Gallery
          </h2>
          
          <p className="text-lg md:text-xl font-medium text-slate-700 mb-8 max-w-2xl mx-auto">
            Explore highlights and memorable moments from our previous events
          </p>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {imageURLs.map((img, idx) => (
              <div 
                key={idx}
                className="relative rounded-lg overflow-hidden shadow-lg hover:shadow-xl bg-gradient-to-br from-slate-100 to-slate-200 aspect-[4/3] group transform hover:scale-105 transition-all duration-300 border border-slate-200"
              >
                <img 
                  src={img} 
                  alt={`Event gallery ${idx + 1}`} 
                  className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110" 
                />
                
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-4">
                  <div className="bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full">
                    <svg className="w-5 h-5 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7" />
                    </svg>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          <div className="mt-8 inline-flex items-center gap-2 text-base font-semibold text-slate-600 bg-slate-100 px-4 py-2 rounded-lg border border-slate-200">
            <svg className="w-5 h-5 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            More photos will be added after the event
          </div>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;